import { SensorData, sensorService } from '@/controllers/sensorService';
import { useEffect, useState } from 'react';

type CalibrationStatus = 'notStarted' | 'success' | 'error';

export type CalibrationStatusArray = [
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
  CalibrationStatus,
];

export function useSensor(sensorId?: string) {
  const [sensorData, setSensorData] = useState<{
    batteryLevel?: number;
    movementHistory?: number[];
    calibrationStatus?: CalibrationStatusArray;
  }>({
    batteryLevel: Math.floor(Math.random() * 100),
    calibrationStatus: [
      'success',
      'success',
      'error',
      'error',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
      'notStarted',
    ] as const,
  });

  useEffect(() => {
    if (!sensorId) return;

    function handleData(_: string, data: SensorData) {
      setSensorData({
        ...data,
        calibrationStatus: Array(15).fill('notStarted') as CalibrationStatusArray,
      });
    }

    sensorService.subscribe(sensorId, handleData);

    return () => {
      sensorService.unsubscribe(sensorId, handleData);
    };
  }, [sensorId]);

  // TODO: We need to add some calls here to start the calibration process etc.

  return sensorData;
}
